import { useTranslation } from 'next-i18next'

import { LeagueType, LeagueNames } from '~/Leaderboard/types/leaderboard.types'
import { getBadgePosition } from '~/Leaderboard/utils/utils'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function LeagueBadge({
  currentLeague,
  highestLeague,
}: {
  currentLeague: number
  highestLeague: number
}): React.ReactElement {
  const { t } = useTranslation('leaderboard')
  const imageSize = 75
  const currentLeagueImageSize = 100
  const imageSizeClassName = currentLeague > 0 ? 'min-w-18.75' : 'min-w-0'

  const position = getBadgePosition(currentLeague)

  return (
    <div className="relative h-36">
      <div
        className={`absolute grid grid-rows-1 grid-flow-col justify-center px-2 ${
          currentLeague > 0 ? 'gap-5' : 'gap-2 md:gap-5'
        } w-screen ${position}`}
      >
        {Object.entries(LeagueType)
          .filter(([, league]) => league !== 0 && typeof league === 'number')
          .map(([key, league]) => (
            <div className="flex justify-center row-start-1 row-span-1 w-full" key={key}>
              <ResponsiveImage
                alt={t(`league.${LeagueNames[key as keyof typeof LeagueNames]}`)}
                className={`${league === currentLeague ? 'min-w-25' : imageSizeClassName} ${
                  Number(league) <= highestLeague ? '' : 'grayscale brightness-25'
                }`}
                height={league === currentLeague ? currentLeagueImageSize : imageSize}
                srcKey={`gamification/badges/league/${key.toLowerCase()}-badge.svg`}
                width={league === currentLeague ? currentLeagueImageSize : imageSize}
              />
            </div>
          ))}
      </div>
    </div>
  )
}
